function getThemeProps(params) {
  const { theme, name } = params;

  if (!name || !theme.props || !theme.props[name]) {
    return {};
  }

  return theme.props[name];
}

export default getThemeProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui/es/styles/getThemeProps.js
// module id = fHaD
// module chunks = 11